
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export const useGroupAdmin = (groupId?: string) => {
  const { user } = useAuth();

  const { data, isLoading, error } = useQuery({
    queryKey: ['group-admin', groupId, user?.id],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('group_members')
        .select('is_admin')
        .eq('group_id', groupId!)
        .eq('user_id', user!.id)
        .maybeSingle();

      if (error) throw error;
      return data?.is_admin ?? false;
    },
    enabled: !!groupId && !!user,
    staleTime: 5 * 60 * 1000,
  });

  return {
    isAdmin: data ?? false,
    loading: isLoading,
    error: error instanceof Error ? error : null,
  };
};
